export const getSessionsAndAverageScore = (activeExercise, sessionHistory) => {
   const { sessionsAtLevel, scoreSum } = sessionHistory.reduce(
      (totals, session) => {
         if (session.level === activeExercise.progress.currentLevel) {
            return {
               sessionsAtLevel: totals.sessionsAtLevel + 1,
               scoreSum: totals.scoreSum + session.score,
            };
         }
         return totals;
      },
      { sessionsAtLevel: 0, scoreSum: 0 }
   );
   const averageSessionScore =
      sessionsAtLevel === 0 ? 0 : scoreSum / sessionsAtLevel;

   return { averageSessionScore, sessionsAtLevel };
};
